/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ExecutionLogDetails {
    getFixupPrototypeFunction() { return ExecutionLogDetails.fixupPrototype; }

    static newInstance(model: Partial<ExecutionLogDetails>): ExecutionLogDetails {
        let obj = Object.assign(new ExecutionLogDetails(), model);
        ExecutionLogDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ExecutionLogDetails>): ExecutionLogDetails {
        if (!model) return null;
        return ExecutionLogDetails.newInstance(<ExecutionLogDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ExecutionLogDetails) {
        if (!obj) return;

        models.ExecutionLogDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ExecutionLogDetails): boolean {
        Object.setPrototypeOf(obj, ExecutionLogDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Status of the Execution Log
     */
    status: string;

    /**
     * Run Time Execution of the schedule
     */
    run_time: string;

    /**
     * Job Name of the schedule execution log
     */
    name: string;

}
